<template>
	<TooltipButton
		size="x-small"
		variant="flat"
		btn-class="upgrade-btn"
		color="primary"
		tooltip-text="Upgrade"
		:btn-text="btnText"
		:to="{ path: '/billing' }"
		v-bind="{ ...$attrs }"
	>
		<template #btnContent>
			<span>{{ btnText }}</span>
			<Upgrade16 />
		</template>
	</TooltipButton>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Upgrade16 from "@carbon/icons-vue/es/upgrade/16";

// Types

// Libraries

// Utilities
import TooltipButton from "@/components/Common/TooltipButton.vue";

// Components

// Stores

// Global variables

export default defineComponent({
	name: "UpgradeButton",
	components: { TooltipButton, Upgrade16 },
	inheritAttrs: false,
	props: { btnText: { type: String, default: "Upgrade" } },
});
</script>

<style lang="scss" scoped>
:deep(.upgrade-btn) {
	min-width: max-content;
	width: auto;
	padding-inline-start: var(--sgnl-space-8);
	padding-inline-end: var(--sgnl-space-4);
}
</style>
